<template>
  <button 
    @click="$emit('click')"
    :class="getClass"
  >
    <slot></slot>
  </button>
</template>
<script>
export default {
  name: "SettingsButton",
  props: {
    type: {
      type: String,
      validator: (type) => ["", "nav", "sidebar", "mini"].includes(type),
    }
  },
  computed: {
    getClass() {
      if (this.type) {
        return this.type+"-button";
      }
      return "";
    }
  }
}
</script>
<style scoped>
button {
  border-radius: 360px;
  border: 1px solid transparent;
  align-items: center;
  transition: 0.1s ease;
  cursor: pointer;
}
button:hover {
  background-color: white;
  border-color: #cecece80;
}
button:disabled {
  background-color: white;
  border-color: #cecece80;
  cursor: default;
  box-shadow: 0px 1px 4px 0px #dcdcdc85;
  color: rgb(44,44,44);
}
.sidebar-button {
  width: 190px;
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  margin-right: 8px;
  margin: 4px 0px;
  padding: 10px 18px;
  text-align: left;
  cursor: pointer;
}
</style>